export const sectorIconMap: Record<string, string> = {
  InformationTechnology: 'TechnologyIcon',
  Healthcare: 'HealthCareIcon',
  ConsumerDiscretionary: 'ConsumerCyclicalsIcon',
  ConsumerStaples: 'ConsumerDefensiveIcon',
  Financials: 'FinancialServicesIcon',
  Energy: 'EnergyIcon',
  RealEstate: 'RealEstateIcon',
  Industrials: 'FactoryIcon',
  CommunicationServices: 'CommunicationServicesIcon',
  Utilities: 'UtilitiesIcon',
  Materials: 'BasicMaterialsIcon',
  Cash: 'LiquidityIcon',
  Miscellaneous: 'OtherSectorsIcon',
};

export const sectorTranslationMap: Record<string, string> = {
  InformationTechnology: 'sectors_technology',
  Healthcare: 'sectors_healthcare',
  Financials: 'sectors_financial_services',
  ConsumerDiscretionary: 'sectors_consumer_cyclicals',
  CommunicationServices: 'sectors_communication_services',
  Materials: 'sectors_basic_materials',
  Energy: 'sectors_energy',
  Industrials: 'sectors_industrials',
  Utilities: 'sectors_utilities',
  RealEstate: 'sectors_real_estate',
  ConsumerStaples: 'sectors_consumer_defensive',
  Cash: 'sectors_cash',
  Miscellaneous: 'sectors_miscellaneous',
};

export function getSectorIcon(sectorName?: string): string {
  if (!sectorName) return 'OtherSectorsIcon';
  return sectorIconMap[sectorName] || 'OtherSectorsIcon';
}

export function getSectorLabelKey(sectorName?: string): string {
  if (!sectorName) return 'sectors_other';
  return sectorTranslationMap[sectorName] || 'sectors_other';
}
